import useReformatCatalog from "@ext/catalog/actions/reformat/useReformatCatalog";
import t from "@ext/localization/locale/translate";
import { useIsStorageConnected } from "@ext/storage/logic/utils/useStorage";
import { Button } from "@ui-kit/Button";
import { Description } from "@ui-kit/Description";
import { Icon } from "@ui-kit/Icon";
import { Loader } from "@ui-kit/Loader";

const ReformatCatalogButton = () => {
	const { isRunning, askToReformat } = useReformatCatalog();
	const isStorageConnected = useIsStorageConnected();
	const prefix = "forms.catalog-extended-edit-props.props.reformat";

	return (
		<div className="flex flex-col gap-2 pt-4">
			<Button className="w-full" disabled={isRunning} onClick={askToReformat} type="button" variant="outline">
				{isRunning ? <Loader className="px-0" size="md" /> : <Icon icon="brush-cleaning" size="md" />}
				{t(`${prefix}.name`)}
			</Button>
			<Description className="flex flex-col gap-1.5" size="xs">
				<p>{t(`${prefix}.description`)}</p>
				{isStorageConnected && <p>{t(`${prefix}.team`)}</p>}
			</Description>
		</div>
	);
};

export default ReformatCatalogButton;
